module.exports = __webpack_public_path__ + "logo-rectangle-db9f51a61ae317da1aaf836f4b8477c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-rectangle.png
// module id = 622
// module chunks = 1